module.exports = __webpack_public_path__ + "assets/img/hero-image-old.23c4618e.png";